import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

/**
 * 停權標記
 *
 * - icon：ban 圖示，疊在小頭像右下角（頭像列表、navbar 切換列表），父層需 position-relative
 * - stamp：「已停權」文字＋方形邊框＋半透明白底，像印章蓋在「我的偶像」卡片封面與頭像上
 *
 * 必須放在套用 .idol-suspended（灰階）的元素之外，否則標記也會一起變灰。
 *
 * @param {'icon'|'stamp'} variant - 標記樣式
 * @param {String} className - 額外類名
 */
function SuspendedMark({ variant, className = '' }) {
  const { t } = useTranslation();

  if (variant === 'icon') {
    return (
      <FontAwesomeIcon
        icon={['fas', 'ban']}
        title={t('suspended')}
        className={`position-absolute bottom-0 end-0 fs-6 bg-white rounded-circle text-danger ${className}`}
      />
    );
  }

  return <span className={`suspended-stamp ${className}`}>{t('suspended')}</span>;
}

SuspendedMark.propTypes = {
  variant: PropTypes.oneOf(['icon', 'stamp']).isRequired,
  className: PropTypes.string,
};

export default SuspendedMark;
